import { createFileRoute } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { Footer, Header, Page, PageContent } from "@/components/page.tsx";
import { LogInForm } from "@/components/log-in-form.tsx";
import { useAudioSlot } from "@/features/audio/kiosk-audio";

export const Route = createFileRoute("/login-screen")({
  component: RouteComponent,
});

function RouteComponent() {
  useAudioSlot("page.login");
  useTranslation();
  return (
    <Page>
      <Header
        backArrowHref={`/login-option-selector-screen`}
        variant={`small`}
      />
      <PageContent>
        <h2 className={`font-helvetica font-bold text-6xl text-center mb-8`}>
          <Trans>Lépj be!</Trans>
        </h2>
        <p className={`flex gap-x-1 items-center mb-14 text-[20px]`}>
          <img src={`/arrow-attention.svg`} className={`size-8`} />
          <Trans>
            Kérjük add meg a felhasználó neved és jelszavad, amit a regisztráció
            során megadtál!
          </Trans>
        </p>
        <LogInForm />
      </PageContent>
      <Footer
        helpText={
          <Trans>
            Bejelentkezéskor a regisztráció során megadott Felhasználónevet és a
            hozzá tartozó jelszót kell megadni. Ha elfelejtetted a jelszót, kérj
            jelszó emlékeztetőt a regisztrációkor megadott email címre, vagy
            kérd az ügyfélszolgálat segítségét!
          </Trans>
        }
      />
    </Page>
  );
}
